import React from "react"
import {CmCollection, CmVideo, SosPressrelease} from "../../../packages/graphql-layer/src";
import CCOHeadline from "../fundamentals/CCOHeadline";
import CCORichText from "../fundamentals/CCORichText/CCORichText";
import CCOContainer from "../fundamentals/CCOContainer";
import {mapDoctypesGalleryToCollection} from "../../utility/componentUtil";
import C018StandardTeaser from "../content/C018StandardTeaser/C018StandardTeaser";
import C008ImageGallery from "../content/C008ImageGallery/C008ImageGallery";
import C003Download from "../content/C003Download/C003Download";
import C022ContactTeaser from "../content/C022ContactTeaser/C022ContactTeaser";
import C041Video from "../content/C041Video/C041Video";
import CCOH1 from "../fundamentals/CCOH1";
import {useTranslation} from "react-i18next";
import C021KachelTeaser from "../content/C021KachelTeaser/C021KachelTeaser";
import CCOComponentWrapper from "../fundamentals/CCOComponentWrapper";
import CCOLocationDate from "../fundamentals/CCOLocationDate";


export interface Props {
    sosPressrelease: SosPressrelease
    CAEGlobalSettings: any,
    csrfToken: string
}


function P012Pressrelease(props: Props) {
    const {t} = useTranslation()
    const isH1Activated = !props.sosPressrelease.settings?.deactivateH1

    return <>
        <CCOComponentWrapper id='main'>
            {!props.sosPressrelease.title ? <></>
                : isH1Activated ?
                    <CCOH1 metadataId={props.sosPressrelease.id} title={props.sosPressrelease.title}
                           isH1Activated={isH1Activated} propertyName='properties.title'></CCOH1>
                    : <CCOHeadline metadataId={props.sosPressrelease.id} headline={props.sosPressrelease.title}
                                   roofLine={props.sosPressrelease.teaserTitle}
                                   propertyName='properties.title'
                                   type='componenthead'
                                   justify='left' strong={false}
                    />
            }
            <CCOContainer>
                {/* Location, Date */}
                <CCOLocationDate metadataId={props.sosPressrelease.id}
                                 location={props.sosPressrelease.location ?? undefined}
                                 propertyName={props.sosPressrelease.extDisplayedDate ? 'properties.extDisplayedDate' : 'properties.modificationDate'}
                                 date={props.sosPressrelease.extDisplayedDate || props.sosPressrelease.modificationDate || ''}/>
                {/* Article */}
                <CCORichText metadataId={props.sosPressrelease.id}
                             textAsTree={props.sosPressrelease.detailText?.textAsTree}
                             propertyName='properties.detailText'
                             docType='pressrelease'></CCORichText>
            </CCOContainer>
        </CCOComponentWrapper>

        {/* Downloads */}
        {props.sosPressrelease.downloads ?
            <C003Download cmCollection={{
                items: props.sosPressrelease.downloads!,
                teaserTitle: 'Downloads'
            } as CmCollection}/>
            : <></>}

        {/* Videos */}
        {props.sosPressrelease.videos && props.sosPressrelease.videos.length > 0 ?
            <> {props.sosPressrelease.videos.map((video: any, index: number) => {
                return <C041Video key={index} video={{dataUrl: video.dataUrl} as CmVideo}/>
            })}
            </>
            : <></>}

        {/*Images gallery*/}
        {props.sosPressrelease.gallery && props.sosPressrelease.gallery.length > 0 ?
            <C008ImageGallery
                gallery={mapDoctypesGalleryToCollection(props.sosPressrelease.gallery, props.sosPressrelease.id)}
                galleryHeadline={props.sosPressrelease.galleryHeadline ?? undefined}/>
            : <></>}

        {/* Contacts */}
        {props.sosPressrelease.contacts ?
            <> {props.sosPressrelease.contacts.map((contact: any, index: number) => {
                return <C022ContactTeaser contactTeaser={contact} key={index}/>
            })} </>
            : <></>}

        {/* Related Pressreleases */}
        {props.sosPressrelease.otherPressreleases && props.sosPressrelease.otherPressreleases.length > 0 ?
            <CCOComponentWrapper>
                <CCOHeadline headline={t('p012_pressrelease_other_pressreleases')}></CCOHeadline>
                <React.Fragment>
                    {props.sosPressrelease.otherPressreleases.map((item: any, index: number) => {
                            return <C018StandardTeaser key={index} cmTeaser={item} displayDate
                                                       hidePicture hideDocType></C018StandardTeaser>
                        }
                    )}
                </React.Fragment>
            </CCOComponentWrapper> : <React.Fragment/>}


        {/* Related Content Items */}
        {props.sosPressrelease.related && props.sosPressrelease.related.length > 1 ?
            <CCOComponentWrapper fullWidthOnMobile customStyle={{minHeight: {md: '300px', lg: '400px', xl: '450px'}}}>
                <C021KachelTeaser
                    cmCollection={{
                        items: props.sosPressrelease.related,
                        teaserTitle: props.sosPressrelease.relatedHeadline
                    } as any}/>
            </CCOComponentWrapper>
            : null}
    </>
}

export default P012Pressrelease